// extracted by mini-css-extract-plugin
module.exports = {"panel":"i_j","text":"i_k"};